import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const ContactUsPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="py-6 px-4 md:px-8 max-w-4xl mx-auto w-full min-h-[70vh] animate-fade-in">
      <div className="flex items-center gap-4 mb-8 border-b border-gray-100 pb-5">
        <button 
          onClick={() => navigate(-1)} 
          className="w-10 h-10 rounded-full bg-white shadow-sm border border-gray-200 hover:bg-gray-50 flex items-center justify-center text-gray-600 transition-colors"
        >
          <i className="fas fa-arrow-left"></i>
        </button>
        <h1 className="text-2xl md:text-3xl font-black text-[#0F2F63] flex items-center gap-3">
          <i className="fas fa-headset text-[#FF7A59]"></i> Contact Us
        </h1>
      </div>

      {/* Centered Big Email Support Card */}
      <div className="max-w-xl mx-auto bg-white p-10 md:p-12 rounded-3xl shadow-sm border border-gray-100 flex flex-col items-center text-center">
        <div className="w-24 h-24 bg-sky-50 rounded-full flex items-center justify-center mb-6 shadow-inner">
          <i className="fas fa-envelope-open-text text-4xl text-sky-600"></i>
        </div>
        <h2 className="text-2xl font-black text-gray-900 mb-3">Get in Touch with Us</h2>
        <p className="text-gray-500 font-medium mb-8 leading-relaxed">
          Have a question, feedback, or facing an issue with your order? Drop us an email and our team will get back to you within 24 hours.
        </p>
        <a 
          href="mailto:svmart19@gmail.com" 
          className="w-full py-4 bg-[#0F2F63] hover:bg-[#1a4a8a] text-white rounded-2xl font-black text-lg transition-all shadow-lg flex items-center justify-center gap-3"
        >
          <i className="fas fa-paper-plane"></i> svmart19@gmail.com
        </a>
      </div>
    </div>
  );
};

export default ContactUsPage;